import { useAppSelector } from "_redux/hooks";
import { efoodSelector } from "_redux/selectors/site";

const useEFoodConfig = () => useAppSelector(efoodSelector);

export { useEFoodConfig };
